import { useEffect, useRef, useState } from "react";

/**
 * Returns `true` only after `delay` ms have passed while `flag` is still true.
 * Useful to avoid loading-skeleton flashes for sub-200ms responses.
 */
export default function useDelayedFlag(flag, delay = 200) {
    const [shown, setShown] = useState(false);
    const t = useRef(null);
    useEffect(() => {
        if (flag) {
            t.current = setTimeout(() => setShown(true), delay);
        } else {
            clearTimeout(t.current);
            setShown(false);
        }
        return () => clearTimeout(t.current);
    }, [flag, delay]);
    return shown;
}
